'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var checkBoxArray = document.querySelectorAll('.form-check input[type=checkbox]');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var checkbox = _step.value;

            window.setTimeout(function () {
                return showHideInput(checkbox);
            }, 1000);
            checkbox.addEventListener('change', function () {
                return showHideInput(checkbox);
            });
        };

        for (var _iterator = (0, _getIterator3.default)(checkBoxArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var topXSubmitButton = document.querySelector('.top-x-submit');
    if (topXSubmitButton && !topXSubmitButton.clickRegistered) {
        topXSubmitButton.addEventListener('click', function (event) {
            var checkbox = document.querySelector('.top-x-enabled-box');
            var topXCountInput = document.querySelector('.top-x-count');
            if (checkbox && !checkbox.checked && topXCountInput && topXCountInput.value === '') {
                topXCountInput.value = '1';
            }
        });
        topXSubmitButton.clickRegistered = true;
    }

    function showHideInput(checkbox) {
        if (!checkbox) {
            console.error('No checkbox assigned into showHideInput method.');
            return;
        }
        var conditionalControlsPane = document.getElementById(checkbox.dataset.controlToDisable);
        if (!conditionalControlsPane) {
            console.error('No conditionalControlsPane found for checkbox: ' + checkbox.id + ' by CSS class: conditional-controls.', checkbox);
            return;
        }

        if (checkbox.checked) {
            conditionalControlsPane.classList.remove('disabled');
        } else {
            conditionalControlsPane.classList.add('disabled');
            if (checkbox.dataset.cleanValue) {
                var formControl = conditionalControlsPane.querySelector('.form-control');
                if (formControl) formControl.value = '';
            }
        }
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/topProductsCommission.js
// module id = 952
// module chunks = 0